module.exports = __webpack_public_path__ + "img/17400.0a4d37e3.jpg";